// Не подставляем первый проект компании молча — если пользователь не выбрал проект явно,
// задача создаётся "без проекта" (кабинеты при выборе тоже показывались неограниченным
// списком, а не списком первого проекта, так что подстановка задним числом была бы
// нечестной по отношению к тому, что человек видел на экране).
export const getDefaultWorkspaceId = (taskForm) => taskForm.workspace_id || null;

export const closeTaskDetail = ({
    setSelectedTask,
    setTaskDetail,
    setTaskComments,
    setTaskCommentBody,
    setTaskEditOpen,
    setTaskDescriptionExpanded,
    setTaskHistoryExpanded,
    setTaskHistory
}) => {
    setSelectedTask(null);
    setTaskDetail(null);
    setTaskComments([]);
    setTaskCommentBody('');
    setTaskEditOpen(false);
    setTaskDescriptionExpanded(false);
    setTaskHistoryExpanded(false);
    setTaskHistory([]);
};
